import { useQuery } from "@tanstack/react-query";
import { getBundledAssetLogo, resolveAssetLogo, type TokenIdentity } from "@/lib/wallet/asset-logos";
import { initialsFor } from "@/lib/wallet/format";

export function AssetLogo({ asset, className = "size-9" }: { asset: TokenIdentity; className?: string }) {
  const bundledLogo = getBundledAssetLogo(asset);
  const logo = useQuery({
    queryKey: ["asset-logo", asset.currency, asset.issuer],
    queryFn: () => resolveAssetLogo(asset),
    enabled: !bundledLogo,
    ...(bundledLogo ? { initialData: bundledLogo } : {}),
    staleTime: 24 * 60 * 60 * 1_000,
    gcTime: 7 * 24 * 60 * 60 * 1_000,
    retry: 1,
  });

  return (
    <span
      className={`readout grid shrink-0 place-items-center overflow-hidden rounded-full bg-elevated text-[10px] text-accent ${className}`}
    >
      {logo.data ? (
        <img
          src={logo.data}
          alt={`${asset.code} logo`}
          width={40}
          height={40}
          loading="eager"
          decoding="async"
          className="size-full object-contain"
        />
      ) : (
        initialsFor(asset.code)
      )}
    </span>
  );
}